import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getOfferById, Offer } from 'app/console-api';
import { SkeletonLoader } from 'app/components/common/skeleton-loader/skeleton-loader';
import { FlexRow } from '@make-software/cspr-design';
import { OfferEditForm } from 'app/components/management/apps/offers/edit/offer-edit-form';
import { LoadingContainer, PageContainer } from 'app/components/common/common-styles';
import { HttpError } from 'app/components/utils/http-error';
import { statusCode } from 'app/constants';
import { SIGN_IN_PATH } from 'app/route/paths';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';

export const OfferEditPage = () => {
  const { appID } = useTabsCtx();
  const { id } = useParams<{ id: string }>();
  const [offer, setOffer] = useState<Offer | undefined>(undefined);

  useEffect(() => {
    const fetchOffer = async () => {
      if (!id) {
        console.error('No ID provided in the route.');
        return;
      }
      getOfferById(appID, id)
        .then((response) => {
          setOffer(response);
        })
        .catch((error: any) => {
          if (error instanceof HttpError) {
            if (error.statusCode === statusCode.authentication_error) {
              window.location.href = SIGN_IN_PATH;
              return;
            }
          }
          console.error('Failed to fetch offer:', error);
        });
    };

    fetchOffer();
  }, [id]);

  if (!offer) {
    return (
      <PageContainer>
        <LoadingContainer>
          <SkeletonLoader height={'300px'} />
        </LoadingContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <FlexRow justify={'center'} align={'center'}>
        <OfferEditForm offer={offer} />
      </FlexRow>
    </PageContainer>
  );
};
